module.exports = __webpack_public_path__ + "static/img/13.3d6c519.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/13.png
// module id = 4f2/
// module chunks = 0